import { useSelector, useDispatch } from 'react-redux';
import { addWaypoint as addInqueryWaypoint, removeWaypoint as removeInquieryWaypoint, changeWaypointLocation, swapWaypoints, updateWaypoint } from '../../store/inquerySlice';
import RouteWaypointSearch from "./RouteWaypointSearch";
import RouteDisplay from "./RouteDisplay";



function RouteScreen(props) {
    const dispatch = useDispatch();

    return (
        <div className="section">
            <div className="column g16 top">
                <div className="column">
                    <p className="title">MARSRUUT</p>
                    <p>Peatused ning saabumis- ja väljumisajad</p>
                </div>
            </div>
            <RouteDisplay/>
        </div>
    );
}

export default RouteScreen;